<template>
<div>
<eta-salle-list :salleList="getSalles" @click:salle="onClickSalle" @update:search="onUpdateSearch" @update:page="onUpdatePage" :page="optionsPaginate.page" :length="optionsPaginate.length" :search="search"/>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EtaSalleListStore',
  data: () => ({
    search: '',
    optionsPaginate: {
      length: 0,
      page: 1
    },
    itemsPerPage: 8
  }),
  computed: {
    ...mapGetters('etablissements', [
      'getSalles',
      'getSallePagination'
    ])
  },
  methods: {
    ...mapActions('etablissements', [
      'retrieveSalles',
      'retrieveSalle'
    ]),
    onClickSalle (idSalle) {
      this.$emit('click:salle', idSalle)
      this.retrieveSalle(idSalle)
    },
    onUpdatePage (v) {
      this.optionsPaginate.page = v
      this.retrieveSallesSearched({ isVisible: true })
    },
    onUpdateSearch (v) {
      this.search = v
      this.optionsPaginate.page = 1
      this.retrieveSallesSearched({ isVisible: true })
    },
    async retrieveSallesSearched () {
      await this.retrieveSalles({
        ...(this.search) ? { search: this.search } : {},
        page: this.optionsPaginate.page - 1,
        itemsPerPage: this.itemsPerPage,
        isVisible: true
      })
      this.optionsPaginate = await this.getSallePagination
    }
  },

  mounted () {
    this.retrieveSallesSearched({ isVisible: true })
  }
}
</script>

<style>

</style>
